export default "__VITE_ASSET__DGRdTcGv__"